import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import api from "../../config/URL";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";

function CurriculumView({ id, open, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(
          `/getAllCourseCurriculumCodesById/${id}`
        );
        setData(response.data);
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };
    if (open && id) {
      fetchData();
    }
  }, [id, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown={false}
    >
      <DialogTitle className="headColor">View Curriculum</DialogTitle>
      <DialogContent>
        {loading ? (
          <div className="text-center">
            <span
              className="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : data ? (
          <div className="container">
            <div className="row py-4">
              <div className="col-md-6 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-6">
                    <p className="fw-medium">Lesson No</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.lessonNo}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-6">
                    <p className="fw-medium">Curriculum Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data.curriculumCode}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-6">
                    <p className="fw-medium">Curriculum Number</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.curriculumNo}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-6">
                    <p className="fw-medium">Status</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data.status}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-3">
                    <p className="fw-medium">Present Message</p>
                  </div>
                  <div className="col-9">
                    <p className="text-muted text-sm">: <span className="ql-editor" dangerouslySetInnerHTML={{ __html: data.templateSettings?.present || "--" }} /></p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-12">
                <div className="row  mb-2 mt-1">
                  <div className="col-3">
                    <p className="fw-medium">Absent Message</p>
                  </div>
                  <div className="col-9">
                    <p className="text-muted text-sm">: <span className="ql-editor" dangerouslySetInnerHTML={{ __html: data.templateSettings?.absent || "--" }} /></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No data available</p>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          className="btn btn-sm btn-border bg-light text-dark"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CurriculumView;